import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import type { LoyaltyOffersHubOffer } from 'loyalty/lib/loyaltyOffersHub/types'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'
import LoyaltyOffersHubOfferGrid from './LoyaltyOffersHubOfferGrid'

interface Props {
  offers: Array<LoyaltyOffersHubOffer>
}

function LoyaltyOffersHubLimitedTimeOffersSection({ offers }: Props) {
  const intl = useIntl()
  const limitedTimeOffersText = intl.formatMessage({
    id: 'INrAMQE9yL5OB-JKGlCT',
    defaultMessage: 'Limited time offers',
    description: 'Heading for limited-time offers section on the Societe offers hub page',
  })

  if (!offers.length) return null

  return <Pane background="none" padding="40 0">
    <Group direction="vertical" gap={24}>
      <Heading variant="heading2">
        {limitedTimeOffersText}
      </Heading>
      <LoyaltyOffersHubOfferGrid offers={offers} />
    </Group>
  </Pane>
}

export default LoyaltyOffersHubLimitedTimeOffersSection
